// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-wrapper ul li {
  color: var(--textsecondarycolor) !important;
}
.list-wrapper ul li .group-identify {
  top: 10px !important;
}
.list-wrapper ul li .group-identify .pi {
  font-size: 1.3rem !important;
  color: #959595 !important;
}
.list-wrapper ul li .badge-count {
  bottom: 0px !important;
}
.list-wrapper ul li.active {
  background: var(--listbackgoundhover) !important;
  color: var(--listcolor) !important;
  border-top: 1px solid #4bf768;
  border-bottom: 1px solid #4bf768;
}
.list-wrapper ul li.active .list-active, .list-wrapper ul li.active .chat-msg-text {
  color: var(--listcolor) !important;
}
.list-wrapper ul li.active ::ng-deep .empty-img {
  background: #9affc6 !important;
}
.list-wrapper ul li:hover {
  background: var(--listbackgoundhover) !important;
}

.group-members .fa-times {
  color: rgb(195, 12, 12) !important;
}

.new-group-members .fa-check {
  color: var(--listcolor) !important;
}

.list-wrapper.list-overflow {
  height: calc(100vh - 220px) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/chat-list/group-userlist/group-userlist.component.scss"],"names":[],"mappings":"AAEQ;EAEI,2CAAA;AAFZ;AAGW;EACC,oBAAA;AADZ;AAEY;EACI,4BAAA;EACA,yBAAA;AAAhB;AAGW;EACC,sBAAA;AADZ;AAKO;EACE,gDAAA;EACA,kCAAA;EACA,6BAAA;EACA,gCAAA;AAHT;AAKS;EACG,kCAAA;AAHZ;AAKQ;EACI,8BAAA;AAHZ;AAQO;EACI,gDAAA;AANX;;AAYI;EACI,kCAAA;AATR;;AAaI;EACK,kCAAA;AAVT;;AAcA;EACI,sCAAA;AAXJ","sourcesContent":[".list-wrapper{\n    ul {\n        li{\n           \n            color: var(--textsecondarycolor) !important;\n           .group-identify{\n            top:10px !important;\n            .pi{\n                font-size:1.3rem !important;\n                color: #959595 !important;\n            }\n           }\n           .badge-count{\n            bottom:0px !important;\n           }\n        }\n       \n       li.active{\n         background:var(--listbackgoundhover) !important;\n         color:var(--listcolor) !important;\n         border-top:1px solid #4bf768;\n         border-bottom: 1px solid #4bf768;\n        \n         .list-active,.chat-msg-text{\n            color:var(--listcolor) !important;\n         }\n        ::ng-deep .empty-img{\n            background: #9affc6 !important;\n         }\n\n       }\n\n       li:hover{\n           background:var(--listbackgoundhover) !important;\n          \n       }\n    }\n}\n.group-members{\n    .fa-times{\n        color: rgb(195, 12, 12) !important;\n    }\n}\n.new-group-members{\n    .fa-check{\n         color:var(--listcolor) !important;\n    }\n}\n\n.list-wrapper.list-overflow {\n    height: calc(100vh - 220px) !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
